import type { ActionButtonProps } from '../commandActions/types'
import { ChangeContributionDataNestedCommand } from './ChangeContributionDataNestedCommand'
import { EmployerAgreementCommandNester } from './EmployerAgreementCommandNester'

export const ChangeContributionDataCommand = (props: ActionButtonProps) => (
  <EmployerAgreementCommandNester
    NestedCommand={ChangeContributionDataNestedCommand}
    {...props}
  />
)
